import { Alert, Typography } from '@mui/material'
import React from 'react'

interface GrafanaMatchPreviewProps {
  instanceCount: number
  // null when a regex can't be evaluated in JS
  matchCount: number | null
}

export const GrafanaMatchPreview: React.FC<GrafanaMatchPreviewProps> = ({
  instanceCount,
  matchCount
}) => {
  if (matchCount === null) {
    return (
      <Typography color="text.secondary" variant="body2">
        Can&apos;t preview matches for this regex here. Grafana will evaluate it
        when you test the Health Check.
      </Typography>
    )
  }

  if (matchCount === 0) {
    return (
      <Alert severity="warning">
        These filters match none of the {instanceCount} current instances, so
        this Health Check will always be healthy until a matching instance
        appears.
      </Alert>
    )
  }

  return (
    <Typography color="text.secondary" variant="body2">
      Matches {matchCount} of {instanceCount} instances
    </Typography>
  )
}
